import { List } from 'immutable';
import { useCallback, useEffect } from 'react';
import { useReframe, dispatch } from 'nike-re-framejs';

import useLoading from '@/_hooks/useLoading';
import { useSavedTicketsSearch } from '@/mytickets/saved/useSavedTicketsSearch';
import { CHAT_TICKETS_SHOW_LIMIT } from '@/forum/chat/constants';
import { ticketusQuickTickets$ } from '@/mytickets/overview/subs';

export function useTicketPickerData(type, status, pick) {
    const { derefSub, subscribe } = useReframe();
    // ticketus
    const tickets = subscribe(ticketusQuickTickets$);
    const [ticketsLoading] = useLoading(tickets.size > 0);

    // saved tickets
    const savedData = derefSub(['ticketus/profile-saved']);
    const { query, searchResult, onQueryChange } = useSavedTicketsSearch('');
    const savedTickets = List(query ? (searchResult && searchResult.size ? searchResult : []) : savedData.get('list'));
    const [savedTicketsLoading, savedTicketsResetLoading] = useLoading(savedTickets.size > 0);

    useEffect(() => {
        dispatch(['ticketus/quicktickets/initialize', type, status, pick]);
        dispatch(['ticketus/profile-saved/initial-load']);
    }, [type, status, pick]);

    const onQueryChangeWithReset = useCallback(
        value => {
            savedTicketsResetLoading();
            onQueryChange(value);
        },
        [onQueryChange, savedTicketsResetLoading]
    );

    return {
        tickets,
        ticketsLoading,
        savedTickets: savedTickets.take(CHAT_TICKETS_SHOW_LIMIT),
        savedTicketsLoading,
        onQueryChange: onQueryChangeWithReset,
        query
    };
}
